"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doTransform = exports.validatePdf2CsvConfig = void 0;
const common_1 = require("@finley-technologies/common");
const validatePdf2CsvConfig = (transformation) => {
    const { fields } = transformation;
    // ensure that fields are not duplicated.
    const uniqueFieldNames = new Set();
    const errors = [];
    fields.forEach(({ name }) => {
        if (uniqueFieldNames.has(name)) {
            errors.push({
                type: 'metadataValidation',
                message: `[field:${name}] is duplicated`,
            });
        }
        else {
            uniqueFieldNames.add(name);
        }
    });
    // ensure all fields specify same number of pages
    // its okay for page numbers to be different for each field
    // but there must be sane number of pages specified for each field
    const uniquePageNumbers = new Set();
    fields.forEach(({ pageNumbers }) => {
        (0, common_1.finleyAssert)(pageNumbers, 'pageNumbers is required');
        uniquePageNumbers.add(pageNumbers.length);
    });
    if (uniquePageNumbers.size > 1) {
        errors.push({
            type: 'metadataValidation',
            message: `all fields must specify same number of pages`,
        });
    }
    if (errors.length > 0) {
        throw errors;
    }
    return null;
};
exports.validatePdf2CsvConfig = validatePdf2CsvConfig;
const doTransform = ({ srcDataTapeBuffer, transformation, pdfExtractor, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        (0, common_1.finleyAssert)(pdfExtractor, 'pdfExtractor is required');
        const { fields } = transformation;
        const queries = fields.map(({ question, pageNumbers }) => ({
            question,
            pageNumbers,
        }));
        const pdfResult = yield pdfExtractor(srcDataTapeBuffer, queries);
        // create a single row csv array, that has the field names as header
        // and the answers as values.
        const csvArray = [
            fields.reduce((acc, { name }, index) => {
                // find the answer for this question
                const { value, confidence, error, pageNumber } = pdfResult.answers[index];
                return Object.assign(Object.assign({}, acc), { [`${name}#value`]: value, [`${name}#confidence`]: confidence, [`${name}#error`]: error, [`${name}#pageNumber`]: pageNumber });
            }, {}),
        ];
        const outputBuffer = common_1.csvConversion.csvArrayToFinleyBuffer({
            csvArray,
        });
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (err) {
        const message = err instanceof common_1.error.FinleyError ? err.message : String(err);
        return {
            isValid: false,
            errors: [
                {
                    type: 'metadataValidation',
                    message,
                },
            ],
        };
    }
});
exports.doTransform = doTransform;
exports.default = {
    doTransform: exports.doTransform,
    validatePdf2CsvConfig: exports.validatePdf2CsvConfig,
};
//# sourceMappingURL=pdf2csv.js.map